import { useTranslation } from 'react-i18next';
import { StyledContainer, StyledSubtitle, StyledTitle } from './styled';

const PricingPageHeader = () => {
  const { t } = useTranslation();

  return (
    <StyledContainer data-testid="pricing-page-header">
      <StyledTitle>{t('subscription:pricing:title')}</StyledTitle>
      <StyledSubtitle>{t('subscription:pricing:subtitle1')}</StyledSubtitle>
    </StyledContainer>
  );
};

export default PricingPageHeader;
